// import { useSetState } from 'ahooks';
import { Button, Input, Modal, Select } from 'antd';
import { debounce } from 'lodash';
import React, { useEffect, useState, useCallback } from 'react';
import closeCircleSvg from './asset/close-circle.svg';
import { notifyError, notifySuccess } from '@shakkerai/pro-components';
import { requestModelTags, submitImageShare } from '@shakkerai/services';
import { useShareImgModalStore } from '@shakkerai/pro-store';
import { presetCheckpointsMap } from '@shakkerai/pro-models';
import { ImageDetail } from './image';
import styles from './ShareImgModal.module.scss';
import { uniqueObjArray } from './utils';
import { translate } from '@shakkerai/util-i18n';
import { mc } from '@shakkerai/report';
import { getElementGenInfo } from '@shakkerai/pro-hooks';

// 评论、分享图片、编辑图片
export const ShareImgModal = ({ isMobile }) => {
  const { hideShareImgModal, imgInfo, batchType, open } = useShareImgModalStore();
  const { url, innerTaskId, innerImageId, width, height } = imgInfo || {};
  const [titleValue, setTitleValue] = useState(''); // 图片标题
  const [descValue, setDescValue] = useState(''); // 图片标题
  const [tagValue, setTagValue] = useState(''); // 图片标签搜索
  const [tags, setTags] = useState([]);
  const [topicList, setTopicList] = useState([]); // 图片标签列表
  const [selectTagsList, setSelectTagsList] = useState([]);
  // const [formValues, setFormValues] = useSetState({
  //   hideGenInfo: 0,
  //   remark: '',
  // });
  const [loading, setLoading] = useState(false);
  const fetchTags = useCallback(
    async (text) => {
      const res = await requestModelTags({
        page: 1,
        tagType: 2,
        tagLabel: text,
        pageSize: 50,
      });
      if (res?.code === 0) {
        const tempList = [...topicList].concat(res?.data?.data || []);
        const uniqueList = uniqueObjArray(tempList, 'id');
        setTopicList(uniqueList);
      }
    },
    [topicList],
  );

  useEffect(() => {
    if (open) {
      fetchTags(tagValue);
    }
    // eslint-disable-next-line
  }, [tagValue, open]);

  const resetStates = () => {
    setTitleValue('');
    setDescValue('');
    setTagValue('');
    setTags([]);
    setTopicList([]);
    setSelectTagsList([]);
    // setFormValues({
    //   hideGenInfo: 0,
    //   remark: '',
    // });
  };

  const onCancel = () => {
    hideShareImgModal(false, false);
    resetStates();
  };

  const submit = async (params) => {
    setLoading(true);
    const res = await submitImageShare(params);
    if (res.code === 0) {
      notifySuccess(translate('image_publish_success'));
      hideShareImgModal(true, true);
      resetStates();
    } else {
      notifyError(res.msg || translate('image_publish_fail'));
    }
    setLoading(false);
  };

  // 保存图片
  const handleSubmit = async () => {
    const info = await getElementGenInfo(imgInfo);
    let baseModel = [];

    if (info?.checkpoint) {
      baseModel = [info?.checkpoint];
    } else if (info?.presetBaseModelId) {
      const _baseModel = presetCheckpointsMap[info.presetBaseModelId]?.versionDetail;
      if (_baseModel) {
        baseModel = [{ ..._baseModel, isPreset: true }];
      }
    }

    const models = baseModel.concat(info?.loraModels || []).map((model) => {
      const data = {
        refType: 0,
        modelId: model?.modelId,
        versionId: model?.versionId,
      };

      if (model.isPreset) {
        data.refType = 1;
      } else if (model.isHiddenStrategy) {
        data.refType = 2;
      }

      return data;
    });

    mc('tool.canvas.share', { image_id: innerImageId, from: 'publish' });

    const params = {
      batchType: batchType || 2,
      title: titleValue,
      remark: descValue,
      // content: descValue,
      tags: selectTagsList,
      // hideGenInfo: formValues.hideGenInfo,
      images: [
        {
          generateInfo: info,
          height,
          width,
          imageUrl: url,
          mixModel: '',
          generateId: innerTaskId,
          outputId: innerImageId,
          models: models,
        },
      ],
    };
    submit(params);
  };

  useEffect(() => {
    // if (open) {
    //   report({
    //     e: 'image.upload.page.show',
    //     t: 1,
    //     var: {
    //       batchType,
    //     },
    //   });
    // }
    // if (!open) {
    //   Object.keys(imgCacheRef.current).forEach((key) => {
    //     window.URL.revokeObjectURL(imgCacheRef.current[key]);
    //   });
    // }
    // return () => {
    //   Object.keys(imgCacheRef.current).forEach((key) => {
    //     window.URL.revokeObjectURL(imgCacheRef.current[key]);
    //   });
    // };
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      unmountOnExit={true}
      className={styles.shareImgModal}
      classNames={{
        body: 'tiny-scrollbar',
        mask: styles.modalMask,
      }}
      closeIcon={<img src={closeCircleSvg} />}
      title={
        <div className={styles.header}>
          <span className={styles.subtitle}>{translate('image_publish_title')}</span>
        </div>
      }
      styles={{
        body: {
          height: '584px',
          overflowY: 'auto',
        },
      }}
      footer={
        <Button loading={loading} className={`${styles.submit} dark:border-[transparent]`} onClick={handleSubmit}>
          {translate('image_publish_btn')}
        </Button>
      }
      width={isMobile ? '100%' : 642}
    >
      <div className={styles.mod}>
        <div className={styles.main}>
          <div className={styles.wrapper1} />
          {/* <div className={`${styles.wrapper2}`}>
            <Checkbox
              checked={!!formValues.hideGenInfo}
              value={formValues.hideGenInfo}
              onChange={() => {
                setFormValues({
                  ...formValues,
                  hideGenInfo: formValues.hideGenInfo ? 0 : 1,
                });
              }}
            />
            <span className={styles.info1}>{translate('Hide image generation information')}</span>
          </div> */}

          <div className={`${styles.imgBox} sortable-list`}>
            <ImageDetail imgData={imgInfo} />
          </div>
        </div>
        <span className={`${styles.comment} dark:opacity-80`}>{translate('image_publish_img_title')}</span>
        <Input
          value={titleValue}
          className={`${styles.imageTitle} dark:bg-[#0C0B10]`}
          onChange={(e) => setTitleValue(e.target.value)}
          maxLength={30}
          showCount
          placeholder={translate('image_publish_img_title')}
        />
        <span className={`${styles.comment} dark:opacity-80`}>{translate('image_publish_img_tags')}</span>
        <Select
          mode="tags"
          placeholder={translate('image_publish_img_tags')}
          value={tags}
          className={`${styles.imageTags} dark:bg-[#0C0B10]`}
          style={{ marginBottom: 16 }}
          onSearch={debounce(setTagValue, 500)}
          onDeselect={(value) => {
            const tempTags = [...tags];
            const index = tempTags.findIndex((tag) => tag === value);
            tempTags.splice(index, 1);
            const tempSelectTagsList = [...selectTagsList];
            tempSelectTagsList.splice(index, 1);
            const selectList = tempSelectTagsList.map((tag) => {
              return {
                id: tag.id,
                tagLabel: tag.tagLabel,
              };
            });
            setSelectTagsList(selectList);
            setTags(tempTags);
          }}
          onSelect={(value) => {
            const tempTags = [...tags];
            if (!tempTags.includes(value)) {
              tempTags.push(value);
            }
            const selectList = tempTags.map((tag) => {
              const topic = topicList.find((topicItem) => topicItem.tagLabel === tag);
              return {
                id: topic?.id || 0,
                tagLabel: tag,
              };
            });
            setSelectTagsList(selectList);
            setTags(tempTags);
          }}
          options={topicList.map((item) => {
            return {
              key: item?.id,
              label: item?.tagLabel,
              value: item?.tagLabel,
            };
          })}
        />
        <span className={`${styles.comment} dark:opacity-80`}>{translate('image_publish_img_desc')}</span>

        {open && (
          <Input.TextArea
            value={descValue}
            className={`${styles.imageDesc} dark:bg-[#0C0B10]`}
            onChange={(e) => setDescValue(e.target.value)}
            maxLength={500}
            autoSize={true}
            placeholder={translate('image_publish_img_desc')}
            showCount
          />
        )}
      </div>
    </Modal>
  );
};
